module.exports = "/_next/static/images/Customer@2x-9140999df358d92091c1d39087453df8.png";